// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.separator {
  height: 15px;
}

.div-see {
  overflow-y: auto;
}
.div-see .card {
  width: 100%;
  margin: 10px auto;
}
.div-see .card .id {
  color: rgb(173, 173, 173);
  font-style: italic;
}

.modal-content {
  padding: 15px;
  width: 700px;
  left: 30px;
  top: 30px;
}

.card-result,
.box-confirm {
  margin: 10px auto;
  width: 90%;
}

.results-container {
  overflow-y: auto;
}

.custom-button {
  background-color: #f0c785;
  border-color: #f0c785;
  box-shadow: 1px 1px 1px rgba(46, 81, 65, 0.48);
  color: white;
}

.custom-button:hover {
  background-color: #f0c785;
  border-color: #f0c785;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/dialog-lookup-permissions/dialog-lookup-permissions.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF;AACE;EACE,WAAA;EACA,iBAAA;AACJ;AACI;EACE,yBAAA;EACA,kBAAA;AACN;;AAIA;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;AADF;;AAIA;;EAEE,iBAAA;EACA,UAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,yBAAA;EACA,qBAAA;EACA,8CAAA;EACA,YAAA;AADF;;AAIA;EACE,yBAAA;EACA,qBAAA;EACA,YAAA;AADF","sourcesContent":[".separator {\r\n  height: 15px;\r\n}\r\n\r\n.div-see {\r\n  overflow-y: auto;\r\n\r\n  .card {\r\n    width: 100%;\r\n    margin: 10px auto;\r\n\r\n    .id {\r\n      color: rgb(173, 173, 173);\r\n      font-style: italic;\r\n    }\r\n  }\r\n}\r\n\r\n.modal-content {\r\n  padding: 15px;\r\n  width: 700px;\r\n  left: 30px;\r\n  top: 30px;\r\n}\r\n\r\n.card-result,\r\n.box-confirm {\r\n  margin: 10px auto;\r\n  width: 90%;\r\n}\r\n\r\n.results-container {\r\n  overflow-y: auto;\r\n}\r\n\r\n.custom-button {\r\n  background-color: #f0c785;\r\n  border-color: #f0c785;\r\n  box-shadow: 1px 1px 1px rgba(46, 81, 65, 0.48);\r\n  color: white;\r\n}\r\n\r\n.custom-button:hover {\r\n  background-color: #f0c785;\r\n  border-color: #f0c785;\r\n  color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
